
import { getCiudadAll, newCiudad } from "../services/serviceCatalog";

const dataInicial = {
  array: [],
  exito: 0,
  codigo: "0",
};

const POST_CATALOGO_CIUDAD_ADD = "POST_CATALOGOS_PAIS_ADD";
const GET_CATALOGO_CIUDAD_ALL = "GET_CATALOGO_CIUDAD_ALL";
const CLEAR_CATALOGO_CIUDAD_ALL = "CLEAR_CATALOGO_CIUDAD_ALL";

export default function catalogoCiudadReducer(state = dataInicial, action) {
  switch (action.type) {
    case CLEAR_CATALOGO_CIUDAD_ALL:
        return { ...state, array: action.payload.array, codigo: action.payload.codigo, exito: action.payload.exito }
    case GET_CATALOGO_CIUDAD_ALL:
        return { ...state, array: action.payload.array, codigo: action.payload.codigo }
    case POST_CATALOGO_CIUDAD_ADD:
      return { ...state, exito: action.payload.exito, array: action.payload.array };
    default:
      return state;
  }
}

export const altaCatalogCiudadAction = (payload) => async (dispatch, getSate) => {
    const codigo = getSate().catalogoCiudad.codigo;
    const response = await newCiudad({ payload });
    const newCatalogo = await getCiudadAll({codigo});
    dispatch({
      type: POST_CATALOGO_CIUDAD_ADD,
      payload: {
        array: newCatalogo,
        exito: 1,
      },
    });
    return response;
};

export const obtenerCatalogoCiudadesAction = (codigo) => async (dispatch) =>{
  console.log(codigo)
    const ciudades = await getCiudadAll({codigo});
    dispatch({
        type: GET_CATALOGO_CIUDAD_ALL,
        payload: {
            array: ciudades,
            codigo: codigo
        }
    })
    return ciudades;
};

export const clearState = () => (dispatch) =>{
    dispatch({
        type: CLEAR_CATALOGO_CIUDAD_ALL,
        payload: {
            dataInicial
        }
    })
}

